import React, { useEffect, useState } from 'react'
import { UseGlobelcourse } from './allcoursecontaxt/ALLCoursecontaxt';
import Gridview from './Gridview';
import Listview from './Listview';
import styled from 'styled-components';
import Filtercourse from './Filtercourse';
import { NavLink } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { BASE_URL } from '../Config/Config';
import SubLoading from '../ALL CSS/Loading';

function Course() {
  const {Allcourse , grid_view , setgridview , setlistview, real_course} =  UseGlobelcourse();
  const { hash } = useLocation();
  const[currentpage , setcurrentpage] = useState(1);
  const itemsPerPage = 9; 
  const [bannerData , setBannerImage] = useState([]);
  const [bannerLoading , setBannerLoading] = useState(true);

  useEffect(() => {
    const fetchBannerImage = async () => {
      try {
        setBannerLoading(true);
        const response = await fetch(`${BASE_URL}/banner/?page=courses`);
        const result = await response.json();
        setBannerImage(result.data[0]);
            } catch (error) {
              console.error('Error fetching banner:', error);
            } finally {
              setBannerLoading(false);
            }
          };
          
          fetchBannerImage();
        }, []);

  // Calculate total pages
  const totalPages = Math.ceil(Allcourse.length / itemsPerPage);

    // slice data for the curent page 
  const currentdata  = Allcourse.slice(
    (currentpage -1 ) * itemsPerPage,
       currentpage * itemsPerPage
  );

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  useEffect(() => {
    // Set background image from data-bg-src
    const bgSrcElements = document.querySelectorAll('[data-bg-src]');
    bgSrcElements.forEach((element) => {
      const src = element.getAttribute('data-bg-src');
      if (src) {
        element.style.backgroundImage = `url(${src})`;
        element.classList.add('background-image');
        element.removeAttribute('data-bg-src');
      }
    });

    // Set background color from data-bg-color
    const bgColorElements = document.querySelectorAll('[data-bg-color]');
    bgColorElements.forEach((element) => {
      const color = element.getAttribute('data-bg-color');
      if (color) {
        element.style.backgroundColor = color;
        element.removeAttribute('data-bg-color');
      }
    });

    // Set mask image from data-mask-src
    const maskSrcElements = document.querySelectorAll('[data-mask-src]');
    maskSrcElements.forEach((element) => {
      const mask = element.getAttribute('data-mask-src');
      if (mask) {
        element.style.maskImage = `url(${mask})`;
        element.style.WebkitMaskImage = `url(${mask})`;
        element.classList.add('bg-mask');
        element.removeAttribute('data-mask-src');
      }
    });
  }, []); 
     

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setcurrentpage(page);
    }
  };


  return (
    <>
    {
      bannerLoading && bannerData && bannerData.image ? (
        <SubLoading/>
      ):(
   <div className="breadcumb-wrapper"

style={{
       backgroundImage: `url(${BASE_URL}${bannerData.image})`,
       backgroundSize: 'fill',
       backgroundPosition: 'center',
      //  backgroundRepeat:"no-repeat",
      //  height:"50px"
     }}
     
          data-overlay="title" data-opacity={8}>

  <div className="breadcumb-shape" data-bg-src="/assets/img/bg/breadcumb_shape_1_1.png">
  </div>
  <div className="shape-mockup breadcumb-shape2 jump d-lg-block d-none" data-right="30px" data-bottom="30px">
    <img src="/assets/img/bg/breadcumb_shape_1_2.png" alt="shape" />
  </div>
  <div className="shape-mockup breadcumb-shape3 jump-reverse d-lg-block d-none" data-left="50px" data-bottom="80px">
    <img src="/assets/img/bg/breadcumb_shape_1_3.png" alt="shape" />
  </div>
  <div className="container">
    <div className="breadcumb-content text-center">
      <h1 className="breadcumb-title">Courses Page</h1>
      <ul className="breadcumb-menu">
        <li><NavLink to="/">Home</NavLink></li>
        <li>Courses</li>
      </ul>
    </div>
  </div>
</div>
      )
    }


<section  id="target-section" className="space-top space-extra2-bottom" >
  <div className="container">
    <div className="row">
      <div className="col-xl-9 col-lg-8 order-lg-2">
        <div className="th-sort-bar course-sort-bar">
          <div className="row justify-content-between align-items-center">

            <div className="col-md">
              <p className="woocommerce-result-count">Showing <span className="text-theme"> {Allcourse.length} courses </span>  of  {real_course.length} </p>
            </div>
            

            <div className="col-md-auto" >
              <div className="nav" role="tablist">

                <a   className = { grid_view  ? 'active' : ' '}id="tab-shop-list" data-bs-toggle="tab" data-bs-target="#tab-list" role="tab" aria-controls="tab-grid" aria-selected="false" onClick={setgridview} style={{cursor:"pointer"}}><i className="fa-solid fa-grid-2 me-2"/>Grid</a>
                <a  className={ grid_view  ? ' ' : 'active'} id="tab-shop-grid" data-bs-toggle="tab" data-bs-target="#tab-grid" role="tab" aria-controls="tab-grid" aria-selected="true" onClick={setlistview} style={{cursor:"pointer"}}><i className="fa-solid fa-list me-2" />List</a>
              </div>
            </div>
          </div>
        </div>
        <div className="tab-content" id="nav-tabContent">
          {grid_view ? <Gridview allcourse={currentdata}/> : <Listview allcourse={currentdata}/> }
        </div>

        <Wrapper>
  <div className="th-pagination-container mt-2" id="coursecontainer">
    <div className="th-pagination text-center pt-50">

      <ul >
        {/* Previous Button */}
        <li>
          <button
            onClick={() => handlePageChange(currentpage - 1)}
            disabled={currentpage === 1}
          >
            <i className="far fa-arrow-left" />
          </button>
        </li>
        {/* Dynamic Page Numbers */}
        {Array.from({ length: totalPages },(_, index) => index + 1).map((page) => (
          <li key={page} className='m-2'>
            <button
              onClick={() => handlePageChange(page)}
              className={currentpage === page ? 'active' : ''}>
              {page}
            </button>
          </li>
        ))}
        {/* Next Button */}
        <li>
          <button
            onClick={() => handlePageChange(currentpage + 1)}
            disabled={currentpage === totalPages}

          >
            <i className="far fa-arrow-right" />
          </button>
        </li>

      </ul>
      
    </div>
  </div>
</Wrapper>
      </div>
     <Filtercourse allcourse={Allcourse}  />
    </div>
  </div>
</section>
    </>
  )
}


const Wrapper = styled.section`
  button {
    border: none;
    outline: none;
  }

  .th-pagination-container {
    position: sticky;
    bottom: 0;
    background-color: #fff;
    z-index: 10;
    padding: 12px 0;
    box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.08);
  }

  .th-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .th-pagination ul {
    display: flex;
    flex-wrap: wrap;
    gap: 12px; /* Better spacing between buttons */
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .th-pagination ul li {
    margin: 0;
  }

  .th-pagination ul li button {
    padding: 8px 16px;
    border: 1px solid #ddd;
    background-color: #fff;
    color: #333;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  .th-pagination ul li button:hover {
    background-color: #007bff;
    color: #fff;
    border-color: #007bff;
  }

  .th-pagination ul li button.active {
    background-color: #007bff;
    color: #fff;
    border-color: #007bff;
    font-weight: 600;
  }

  .th-pagination ul li button:disabled {
    background-color: #f2f2f2;
    color: #aaa;
    cursor: not-allowed;
    border-color: #eee;
    box-shadow: none;
  }

  @media (max-width: 576px) {
    .th-pagination ul {
      gap: 8px;
    }

    .th-pagination ul li button {
      padding: 6px 10px;
      font-size: 12px;
    }
  }
`;



export default Course